import { useState } from 'react';
import {useTranslation} from '../../hook/useTranslation';
import {BreakpointsSettings} from '@octavius-rocks/ui'

export default ({config})=>{
	const i18n = useTranslation("breakpointsConfig");
	const [options, setOptions] = useState(config);
	return <div>
		<p>{i18n.description}</p>
		<BreakpointsSettings
			options={options}
			i18n={i18n}
			onChange={(bs)=>{
				setOptions(bs)
			}}
		/>
		{options.map((o,index)=>
			["key", "maxWidth", "minWidth"].map(name =>
				<input
					key={index+"-"+name}
					type="hidden"
					name={`octavius_rocks_realtime_breakpoints[${index}][${name}]`}
					value={o[name]}
				/>
			)
		)}
	</div>
};